import { useEffect } from 'react';
import { useHistory, useRouteMatch } from 'react-router-dom';
import './style.less';

const HomePage = () => {
  const history = useHistory();
  const match = useRouteMatch();

  useEffect(() => {
    if (match.isExact) {
      history.replace('/login');
    }
  }, [match]);

  return null;
};

export default HomePage;
